import { useEffect, useState, type ReactNode } from 'react'
import { applyConsent, initPostHog, DEFAULT_CONSENT, type ConsentChoice } from './posthog'
import { ConsentContext } from './consentContext'

const STORAGE_KEY = 'ode-consent-v2'

const PH_KEY = (import.meta.env.VITE_POSTHOG_KEY as string | undefined) ?? ''
const PH_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://eu.i.posthog.com'

function readStored(): ConsentChoice | null {
  if (typeof window === 'undefined') return null
  const raw = window.localStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as ConsentChoice
  } catch {
    return null
  }
}

export function ConsentProvider({ children }: { children: ReactNode }) {
  const [choice, setChoiceState] = useState<ConsentChoice | null>(() => readStored())

  useEffect(() => {
    if (PH_KEY) initPostHog(PH_KEY, PH_HOST)
  }, [])

  useEffect(() => {
    if (choice) applyConsent(choice)
  }, [choice])

  const setChoice = (c: ConsentChoice) => {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(c))
    setChoiceState(c)
  }

  const resetChoice = () => {
    window.localStorage.removeItem(STORAGE_KEY)
    setChoiceState(null)
    applyConsent(DEFAULT_CONSENT)
  }

  return <ConsentContext.Provider value={{ choice, setChoice, resetChoice }}>{children}</ConsentContext.Provider>
}
